import { JSX, useContext, useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { APIconNames, APIconsSettings, APThemeProvider, getTheme } from '@ap/design-system';
import { AppContext } from './App';
import '../template/assets/style/main.scss';

interface Props {
  children: JSX.Element;
}

interface Props2 {
  children: JSX.Element;
  /**
   * The theme to use for the design system.
   */
  theme: 'light' | 'dark';
}

export const iconsList = [
  'Accessibility',
  'AccessibilityNew',
  'AccountBalanceWallet',
  'AccountCircle',
  'Add',
  'AddReaction',
  'AddShoppingCart',
  'Analytics',
  'Apartment',
  'ArrowBack',
  'ArrowDownward',
  'ArrowDropDown',
  'ArrowForwardIos',
  'ArrowRange',
  'ArrowUpward',
  'Atm',
  'AttachMoney',
  'Badge',
  'BatteryStatusGood',
  'Beenhere',
  'BrandingWatermark',
  'Browse',
  'Build',
  'BuildCircle',
  'BusinessCenter',
  'CalendarMonth',
  'Call',
  'Cameraswitch',
  'Category',
  'Celebration',
  'ChangeCircle',
  'Check',
  'CheckBox',
  'ChevronLeft',
  'ChevronRight',
  'Circle',
  'CleaningServices',
  'ClearAll',
  'ClockLoader20',
  'ClockLoader90',
  'Close',
  'Construction',
  'CreditCard',
  'CreditCardGear',
  'Crop169',
  'Crop32',
  'DarkMode',
  'DashboardCustomize',
  'DateRange',
  'Delete',
  'DeleteForever',
  'Diamond',
  'DirectionsWalk',
  'DragIndicator',
  'Edit',
  'Event',
  'EventBusy',
  'EventRepeat',
  'FeaturedVideo',
  'FilterList',
  'FilterListOff',
  'Flag',
  'FlashlightOff',
  'FlashlightOn',
  'Group',
  'Groups',
  'Hail',
  'Handshake',
  'Healing',
  'Height',
  'Help',
  'History',
  'HomeRepairService',
  'House',
  'ImageSearch',
  'Info',
  'Input',
  'KeyboardArrowDown',
  'KeyboardArrowRight',
  'KeyboardArrowUp',
  'Language',
  'LightMode',
  'Link',
  'LocalBar',
  'Lock',
  'LockOpen',
  'Logout',
  'MarkEmailRead',
  'MeetingRoom',
  'Menu',
  'MenuOpen',
  'ModeOfTravel',
  'MoreVert',
  'Newspaper',
  'Notes',
  'Notifications',
  'NotificationsOff',
  'OpenInNew',
  'Output',
  'Paid',
  'Payments',
  'Person',
  'PersonAdd',
  'PersonSearch',
  'PhoneIphone',
  'Psychology',
  'QrCodeScanner',
  'RadioButtonChecked',
  'Redeem',
  'Refresh',
  'Restaurant',
  'Schedule',
  'School',
  'Search',
  'Sell',
  'ServiceToolbox',
  'Settings',
  'ShoppingBag',
  'ShoppingBasket',
  'ShoppingCartCheckout',
  'Shuffle',
  'Snowshoeing',
  'Star',
  'Stars',
  'Storefront',
  'Summarize',
  'SupervisorAccount',
  'SupportAgent',
  'SwapHoriz',
  'Theaters',
  'Tune',
  'Undo',
  'Upgrade',
  'UploadFile',
  'Visibility',
  'VisibilityOff',
  'Warning',
  'Watch',
  'WavingHand',
  'Web',
  'ZoomIn',
];

const iconsSettings: APIconsSettings = {
  icons: iconsList as APIconNames[],
  // Optional: list of weights for the icons
  // If not provided, the default weights are 300 and 400
  // weights: [200, 300, 400],
  // Optional: list of optical sizes for the icons
  // If not provided, the default optical sizes is 24
  // opticalSize: [24, 48],
};

function AppThemeProvider2(props: Props2) {
  const theme = useMemo(() => {
    return getTheme(props.theme);
  }, [props.theme]);

  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
}

function AppThemeProvider(props: Props) {
  const { regionalFormat, darkMode } = useContext(AppContext);

  return (
    <AppThemeProvider2 theme={darkMode ? 'dark' : 'light'}>
      <APThemeProvider theme={darkMode ? 'dark' : 'light'} iconsSettings={iconsSettings}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={regionalFormat}>
          {props.children}
        </LocalizationProvider>
      </APThemeProvider>
    </AppThemeProvider2>
  );
}

export default AppThemeProvider;
